/**
 * Cache keys for service tracking-related queries and mutations
 */
export const serviceTrackingKeys = {
  all: ['service-tracking'] as const,
  get: (code: string) => [...serviceTrackingKeys.all, 'get', code] as const,
}
